import { css } from 'styled-components';
import { IconStyled } from '../components/icon';
import { SizeProps } from './size';
import { font } from './font';
import { colors } from './color';

export const form: {
  input: {
    [key in SizeProps]?: {
      height: number;
      fontSize: number;
      lineHeight: number;
      radius: number;
      padding: number[];
    };
  };
} = {
  input: {
    sm: {
      height: 32,
      fontSize: font.size.sm,
      lineHeight: 19.6,
      radius: 4,
      padding: [7, 10],
    },
    md: {
      height: 40,
      fontSize: font.size.md,
      lineHeight: 16,
      radius: 4,
      padding: [12],
    },
    lg: {
      height: 50,
      fontSize: font.size.lg,
      lineHeight: 20,
      radius: 4,
      padding: [15, 15],
    },
  },
};

export const formControlSizeVariant = ($size: SizeProps) => css`
  font-size: ${form.input[$size]?.fontSize}px;
  line-height: ${form.input[$size]?.lineHeight}px;
  padding: ${form.input[$size]?.padding.map(e => `${e}px`).join(' ')};
`;

export const formControlBasic = css`
  width: 100%;
  display: block;
  box-sizing: border-box;
  appearance: none;
`;

export const FormDefault = {
  controlLabelColor: colors.primary,
  controlInputColor: colors.primary,
  controlInputColorDisabled: colors.grayMedium,
  controlInputBgColor: colors.white,
  controlInputBgColorError: colors.warning,
  controlInputBgColorDisabled: colors.grayUltraLight,
  controlInputPlaceholderColor: colors.grayDarker,
  controlInputBorder: `1px solid ${colors.grayMedium}`,
  controlInputBorderFocus: `1px solid ${colors.blue}`,
  controlInputBorderError: `1px solid ${colors.warning}`,
  controlInputBorderDisabled: `1px solid ${colors.grayMedium}`,
};

export const formControlColorVariant = () => css`
  color: ${FormDefault.controlInputColor};
  background-color: ${FormDefault.controlInputBgColor};
  border: ${FormDefault.controlInputBorder};

  &.is-invalid {
    border-color: ${colors.error};
  }
  &.is-success {
    border-color: ${colors.success};

    & + ${IconStyled} {
      opacity: 1;
      z-index: 0;
    }
  }
`;

export const formControlPlaceholder = css`
  &::-webkit-input-placeholder {
    color: ${FormDefault.controlInputPlaceholderColor};
    text-transform: none;
  }
  &::-moz-placeholder {
    color: ${FormDefault.controlInputPlaceholderColor};
    text-transform: none;
  }
  &:-ms-input-placeholder {
    color: ${FormDefault.controlInputPlaceholderColor};
    text-transform: none;
  }
`;

export const formControlFocusVariant = css`
  &:focus {
    border: ${FormDefault.controlInputBorderFocus};
    box-shadow: 0 0 0 2px rgba(0, 103, 244, 0.5);
  }
`;

export const formControlDisabledVariant = css`
  &:disabled {
    color: ${FormDefault.controlInputColorDisabled};
    background-color: ${FormDefault.controlInputBgColorDisabled};
    border-color: ${FormDefault.controlInputBorderDisabled};
  }
`;
